import confetti from "canvas-confetti";

export function fireConfetti({ particleCount = 160 } = {}) {
  const canvas = document.createElement("canvas");
  Object.assign(canvas.style, {
    position: "fixed", inset: "0", width: "100%", height: "100%",
    pointerEvents: "none", zIndex: "9999",
  });
  document.body.appendChild(canvas);
  const fire = confetti.create(canvas, { resize: true });
  const colors = ["#C8102E", "#ffffff", "#4caf50", "#1976d2"];
  const shared = { particleCount, spread: 70, startVelocity: 55, colors, ticks: 200 };
  Promise.all([
    fire({ ...shared, origin: { x: 0.05, y: 1 }, angle: 60 }),
    fire({ ...shared, origin: { x: 0.95, y: 1 }, angle: 120 }),
  ]).then(() => canvas.remove());
}
